import { Menu, UnstyledButton } from "@mantine/core";
import { IconCheck, IconLanguage } from "@tabler/icons-react";
import { LOCALES, type Locale } from "../../shared/i18n";
import { useLocale } from "../i18n/provider";
import styles from "./language-switcher.module.css";

const NAMES: Record<Locale, string> = {
  en: "English",
  vi: "Tiếng Việt",
};

export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { locale, setLocale } = useLocale();

  return (
    <Menu position="bottom-end" width={160} shadow="md">
      <Menu.Target>
        <UnstyledButton
          className={styles.trigger}
          aria-label={`Language: ${NAMES[locale]}`}
          title={NAMES[locale]}
        >
          <IconLanguage size={18} stroke={1.5} />
          {compact ? null : <span>{NAMES[locale]}</span>}
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        {LOCALES.map((value) => (
          <Menu.Item
            key={value}
            onClick={() => setLocale(value)}
            rightSection={value === locale ? <IconCheck size={15} stroke={1.5} /> : null}
          >
            {NAMES[value]}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
